export default __webpack_public_path__ + "static/media/Goranov.96391e05.jpg";